/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "./type";
import { UIElementPropertyAccessorFactory } from "./UIElementPropertyAccessorFactory";
import { MatrixTransform } from "./MatrixTransform";
import { TransformMatrixHelpler } from "./TransformMatrixHelpler";
/**
 * @hidden
 */
var NativeUI = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(NativeUI, _super);
    function NativeUI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NativeUI.aa = function (a, b, c) {
        var d = UIElementPropertyAccessorFactory.c.a(a);
        d.c(b, c);
    };
    NativeUI.i = function (a, b) {
        var c = UIElementPropertyAccessorFactory.c.a(a);
        return c.b(b);
    };
    NativeUI.t = function (a, b) {
        NativeUI.aa(1, a, b);
    };
    NativeUI.e = function (a) {
        return NativeUI.i(1, a);
    };
    NativeUI.j = function (a, b) {
        NativeUI.aa(2, a, b);
    };
    NativeUI.ad = function (a) {
        return NativeUI.i(2, a);
    };
    NativeUI.k = function (a, b) {
        NativeUI.aa(3, a, b);
    };
    NativeUI.ae = function (a) {
        return NativeUI.i(3, a);
    };
    NativeUI.m = function (a, b) {
        NativeUI.aa(4, a, b);
    };
    NativeUI.ai = function (a) {
        return NativeUI.i(4, a);
    };
    NativeUI.l = function (a, b) {
        NativeUI.aa(5, a, b);
    };
    NativeUI.u = function (a, b) {
        NativeUI.aa(6, a, b);
    };
    NativeUI.ak = function (a) {
        return NativeUI.i(6, a);
    };
    NativeUI.ac = function (a) {
        return NativeUI.i(5, a);
    };
    NativeUI.n = function (a, b) {
        NativeUI.aa(7, a, b);
    };
    NativeUI.af = function (a) {
        return NativeUI.i(7, a);
    };
    NativeUI.p = function (a, b) {
        NativeUI.aa(8, a, b);
    };
    NativeUI.b = function (a) {
        return NativeUI.i(8, a);
    };
    NativeUI.ab = function (a, b) {
        NativeUI.aa(9, a, b);
    };
    NativeUI.h = function (a) {
        return NativeUI.i(9, a);
    };
    NativeUI.q = function (a, b) {
        NativeUI.aa(10, a, b);
    };
    NativeUI.c = function (a) {
        return NativeUI.i(10, a);
    };
    NativeUI.r = function (a, b) {
        NativeUI.aa(11, a, b);
    };
    NativeUI.d = function (a) {
        return NativeUI.i(11, a);
    };
    NativeUI.s = function (a, b) {
        NativeUI.aa(13, a, b);
    };
    NativeUI.aj = function (a) {
        return NativeUI.i(13, a);
    };
    NativeUI.z = function (a, b) {
        var c = TransformMatrixHelpler.f(b);
        var d = new MatrixTransform();
        d.j = c;
        NativeUI.aa(14, a, d);
    };
    NativeUI.ah = function (a) {
        return NativeUI.i(14, a);
    };
    NativeUI.v = function (a, b) {
        NativeUI.aa(15, a, b);
    };
    NativeUI.o = function (a, b) {
        NativeUI.aa(16, a, b);
    };
    NativeUI.ag = function (a) {
        return NativeUI.i(15, a);
    };
    NativeUI.y = function (a, b) {
        NativeUI.aa(17, a, b);
    };
    NativeUI.g = function (a) {
        return NativeUI.i(17, a);
    };
    NativeUI.w = function (a, b) {
        NativeUI.aa(18, a, b);
    };
    NativeUI.a = function (a) {
        return NativeUI.i(18, a);
    };
    NativeUI.x = function (a, b) {
        NativeUI.aa(19, a, b);
    };
    NativeUI.f = function (a) {
        return NativeUI.i(19, a);
    };
    NativeUI.$t = markType(NativeUI, 'NativeUI');
    return NativeUI;
}(Base));
export { NativeUI };
//# sourceMappingURL=NativeUI.js.map
